import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getQuizResult = createAsyncThunk("quiz/calculateresult", async (reqbody) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api7/get-quiz-correct-answer", requestOptions);
    const respdata = await response.json();
    return respdata;
});

export const viewQuizResult = createAsyncThunk("quiz/viewresult", async (reqbody) => {

    console.log("reqbodyyyyyyyyyyyyyyyyyyyyyyyyyyy",reqbody);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api7/get-quiz-result", requestOptions);
    const respdata = await response.json();
    return respdata;
});


export const getQuizQuestion = createAsyncThunk("quiz/quizquestion", async (reqbody) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api7/get-quiz-question", requestOptions);
    const respdata = await response.json();
    return respdata;
});




const quizReducer = createSlice({
    name: 'quizReducer',
    initialState: {
        quizSet : [],
        loading: false,
        result: null,
        selectedLesson:null,
        viewresult: false,
    },
    reducers: {
        resetState(state,action){
            state.quizSet= []
            state.loading= false
            state.result= null
            state.selectedLesson=null
            state.viewresult= false
        }
        
    },
    extraReducers: {
        [getQuizResult.pending]: (state, action) => {
            state.loading = true;
        },
        [getQuizResult.fulfilled]: (state, action) => {
            state.loading = true; 
            if(action.payload.status == "success"){
                state.result =action.payload.results;
            }
            console.log("action fetch 666", action)
        },
        [getQuizResult.rejected]: (state, action) => {
            state.loading = false;
        },
        [getQuizQuestion.pending]: (state, action) => {
            state.loading = true;
            state.quizSet = [];
        },
        [getQuizQuestion.fulfilled]: (state, action) => {
            state.loading = false;
            state.quizSet = action.payload.results.res;
            state.selectedLesson = action.meta.arg.searchcondition.lesson_id;
        },
        [getQuizQuestion.rejected]: (state, action) => {
            state.loading = false;
        },
        [viewQuizResult.pending]: (state, action) => {
            state.loading = true;
        },
        [viewQuizResult.fulfilled]: (state, action) => {
            state.loading = false; 
            if(action.payload.status == "success"){
                state.result =action.payload.results[0].result[0];
                state.viewresult= true;
            }
            console.log("action fetch 666", action)
        },
        [viewQuizResult.rejected]: (state, action) => {
            state.loading = false;
        },

    }
})


export const {resetState } = quizReducer.actions;
export default quizReducer.reducer;